<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import type { FinanceOperationGroup } from "@/composables/history/useHistoryFinances";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";

defineProps<{
  operations: FinanceOperationGroup[];
  formatInternalName: (name: string) => string;
}>();

const { t } = useI18n();
</script>

<template>
  <div class="history-body__details">
    <div v-if="!operations.length" class="history-body__details-empty">
      <div class="history-body__details-empty_title">
        <p class="caption-medium color-text-secondary">
          {{ t("history.empty") }}
        </p>
      </div>
    </div>
    <div v-else class="history-body__details-list">
      <div
        v-for="(day, index) in operations"
        :key="index"
        class="history-body__details-list_item"
      >
        <div class="history-body__details-list_day">
          <p class="h3 color-grey-light">{{ day.date }}</p>
        </div>
        <div
          v-for="(op, idx) in day.operations"
          :key="`${day.date}-${idx}`"
          class="history-body__details-list_info"
        >
          <BaseFigureForIcon
            class="history-body__details-list_icon"
            :icon="`${op.type === 'minus' ? 'sim' : 'ruble'}`"
            color="grey-full"
            radius="16px"
            size="large"
          />
          <div class="history-body__details-list_title">
            <p class="h4">{{ formatInternalName(op.internal_name) }}</p>
            <p class="caption-small">{{ op.name }}</p>
          </div>
          <div class="history-body__details-list_numbers">
            <p class="h3" :class="op.type === 'plus' ? 'plus' : ''">
              <template v-if="op.amount === 0">{{ op.amount }} ₽</template>
              <template v-else>
                {{ op.type === "minus" ? "-" : "+" }}{{ op.amount }} ₽
              </template>
            </p>
            <p class="caption-small">{{ op.time }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/components/history-finances";
</style>
